import type {ReactNode} from 'react'
import {ProjectsPicker} from './ProjectsPicker'
import {SidebarSection} from './SidebarSection'

export function ProjectsSection({children}: {children: ReactNode}) {
  return (
    <SidebarSection title="Projects" header={<ProjectsPicker />}>
      {children}
    </SidebarSection>
  )
}
